import { useNavigate } from 'react-router-dom';
import { Github, Linkedin, Mail } from 'lucide-react';
import personalInfo from './personalInfo';
import SkillsList from './SkillsList';
import ExperienceList from './Experience';
import Education from './Education';

export default function HomePage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-stone-50">
      <div className="max-w-5xl mx-auto px-8 py-14">

        {/* Back link */}
        <button
          onClick={() => navigate('/')}
          className="section-label text-stone-400 hover:text-stone-700 transition-colors mb-10 block"
        >
          ← Home
        </button>

        {/* Header */}
        <header className="flex items-end justify-between mb-2">
          <div>
            <h1 className="text-5xl font-extrabold tracking-tight text-stone-900 leading-none mb-2">
              {personalInfo.name}
            </h1>
            <p className="text-lg text-stone-400 font-light">{personalInfo.title}</p>
          </div>
          <div className="flex items-center gap-5 pb-1">
            <a
              href={`mailto:${personalInfo.contact.email}`}
              className="text-stone-400 hover:text-stone-900 transition-colors"
              aria-label="Email"
            >
              <Mail size={20} />
            </a>
            <a
              href={`https://github.com/${personalInfo.contact.github}`}
              target="_blank"
              rel="noreferrer"
              className="text-stone-400 hover:text-stone-900 transition-colors"
              aria-label="GitHub"
            >
              <Github size={20} />
            </a>
            <a
              href={`https://www.linkedin.com/in/${personalInfo.contact.linkedin}`}
              target="_blank"
              rel="noreferrer"
              className="text-stone-400 hover:text-stone-900 transition-colors"
              aria-label="LinkedIn"
            >
              <Linkedin size={20} />
            </a>
          </div>
        </header>

        <hr className="rule mb-10" />

        {/* Body: 2-column */}
        <div className="grid grid-cols-3 gap-16">

          {/* Left — Experience (2/3) */}
          <main className="col-span-2">
            <p className="section-label mb-6">Experience</p>
            <ExperienceList experiences={personalInfo.experience} />
          </main>

          {/* Right — Skills + Education (1/3) */}
          <aside className="col-span-1">
            <div className="mb-10">
              <p className="section-label mb-4">Skills</p>
              <SkillsList skills={personalInfo.skills} />
            </div>

            <hr className="rule mb-8" />

            <div>
              <p className="section-label mb-4">Education</p>
              <Education education={personalInfo.education} />
            </div>
          </aside>

        </div>
      </div>
    </div>
  );
}
